/**
 * 繁體中文語系資源(第一階段)。
 * key 命名:common.* 為跨頁共用;各模組 <module>.<page>.<key>。
 * 英文語系與匯出雙語為第二階段(見主計劃);此處先預埋架構 + 繁中。
 */
const zhHant = {
  common: {
    add: "新增",
    edit: "編輯",
    delete: "刪除",
    view: "檢視",
    search: "查詢",
    reset: "清空",
    submit: "送出審核",
    export: "匯出",
    import: "批次匯入",
    confirm: "確認",
    cancel: "取消",
    save: "儲存",
    perPage: "每頁 {{n}}",
    // 罐頭訊息(對應 MSG 字典)
    createdSubmitted: "已建立並送出審核",
    updated: "已更新",
    deleted: "已刪除",
    importDone: "匯入完成",
  },
  accounts: {
    title: "人員管理",
    users: {
      title: "使用者管理",
      keyword: "關鍵字(姓名/帳號/Email/部門)",
      fields: {
        name: "姓名",
        account: "帳號",
        employeeId: "員工編號",
        email: "Email",
        department: "部門",
        title: "職稱",
        phone: "分機/手機",
        role: "角色",
        adAccount: "AD 帳號",
        hireDate: "到職日",
        status: "狀態",
        approval: "審核",
      },
      adHint: "AD 帳號由後端 AD 同步維護(先留欄位),此處不觸發真同步。",
      statusFilter: "狀態",
      deleteTitle: "刪除使用者",
      goWorkItems: "前往工作管理",
      deleteConfirm: "確定刪除此使用者？此操作將送入審核。",
      importTitle: "使用者批次匯入",
      newUser: "新增使用者",
      editUser: "編輯使用者",
      resetPassword: "重設密碼",
      resetTitle: "重設密碼",
      resetConfirm: "將寄送密碼重設連結至使用者 Email(30 分鐘內有效),確定執行？",
      resetSent: "已寄送密碼重設連結(30 分鐘內有效)",
    },
  },
  rooms: {
    title: "機房管理",
    pageTitle: "機房位置",
    keyword: "關鍵字(名稱/代碼/縣市)",
    cityFilter: "縣市",
    fields: {
      name: "機房名稱",
      code: "代碼",
      city: "縣市",
      address: "地址",
      cabinetCount: "機櫃數",
      approval: "審核",
    },
    newRoom: "新增機房",
    editRoom: "編輯機房",
    deleteTitle: "刪除機房",
    deleteConfirm: "確定刪除此機房？此操作將送入審核。",
    importTitle: "機房批次匯入",
  },
  notify: {
    title: "訊息查詢",
    keyword: "輸入訊息關鍵字",
    clearFilter: "清空條件",
    markAllRead: "全部標示已讀",
    allMarkedRead: "已全部標示為已讀",
    markReadFailed: "標示已讀失敗:{{reason}} 請再試一次。",
    channel: "通知管道",
    overdue: "到期",
    empty: "目前沒有符合條件的訊息",
    noOwner: "無法確認您的登入身分,請重新登入後再查看訊息。",
    // v2(2128:29123)的七個型別分頁;「未讀」不是分頁,以紅點與淺藍底呈現
    tabs: {
      all: "全部",
      unfilled: "資料未填",
      due: "到期類型",
      stock: "低於庫存",
      approval: "審核流程",
      alert: "告警類型",
      version: "版本更新",
    },
    countSummary: "顯示 {{from}}~{{to}} 筆,共 {{total}} 筆",
  },
};

export default zhHant;
